import styled from 'styled-components';

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 2px solid #525252;
  margin-bottom: 44px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

const SwitchText = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: #ffffffdd;
`;

export const SwitchLeftText = styled(SwitchText)`
  margin-right: 10px;
`;

export const SwitchRightText = styled(SwitchText)`
  margin-left: 10px;
`;
